module.exports = __webpack_public_path__ + "img/Fb-research-tw.151a744a.png";